import React from "react";
import { useDispatch } from "react-redux";
import { useAuth0 } from "@auth0/auth0-react";
import {
    stepPath,
    BROADCAST_CHANNEL_NAME,
    BROADCAST_CHANNEL_LOGOUT_MSG,
} from "../../constants";
import { handleLogout as handleLogoutAction } from "../Login/actions";
import UnfoldLogo from "../../ui/logos/UnfoldLogo";

function ContactIT() {
    const dispatch = useDispatch();
    const auth0 = useAuth0();

    function handleLogoutClick(e) {
        e.preventDefault();
        dispatch(handleLogoutAction());
        const logoutChannel = new BroadcastChannel(BROADCAST_CHANNEL_NAME);
        logoutChannel.postMessage(BROADCAST_CHANNEL_LOGOUT_MSG);
        auth0.logout({
            logoutParams: { returnTo: window.location.origin + stepPath.LOGIN },
        });
    }

    return (
        <div className="-mt-10 flex h-[calc(100vh+40px)] w-screen flex-col items-center justify-center overflow-y-auto bg-(--backgroundOffWhite) pb-10">
            <UnfoldLogo />
            <div className="rounded-xl bg-white px-16 py-20 text-center">
                <p className="pb-6">Your account registration is incomplete.</p>
                <p>
                    Please contact{" "}
                    <a
                        className="text-primary-500"
                        href="mailto:support@avendahealth.com"
                    >
                        Avenda Health Support
                    </a>{" "}
                    to complete registration of your account.
                </p>
                <button
                    id="back-to-login-btn"
                    className="text-primary-500 mt-8 outline-hidden hover:underline"
                    onClick={handleLogoutClick}
                >
                    Already registered? Back to Login
                </button>
            </div>
        </div>
    );
}

export default ContactIT;
